import React, { memo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { dataLayer, utilities } from '@weatherbug/common';
import { reduxConnect } from '../../common';
import { SnowSkiPageView } from './snowSkiPageView';
import { getSnowSki } from '../../common/actions/snowSkiActions';

const { getHourlyForecastByLatLon, getDailyForecastByLatLon, getCurrentStationObsByLatLon } = dataLayer.actions;
const { temperatureUnits } = utilities.units;

const mapStoreStateToProps = storeState => {
    const { resorts } = storeState.snowSki || {};
    const appState = storeState.appState.appState || {};
    const {
        locality,
        forecastBaseUrl,
        contentMgmtBaseUrl,
        snowSkiBaseUrl,
        forecastIconResourceList,
        forecastIconSize,
        forecastIconSet,
        authId,
        secret,
        obsBaseUrl,
        stdParameters,
        user
    } = appState;

    return {
        latitude: locality?.Latitude,
        longitude: locality?.Longitude,
        forecastBaseUrl,
        contentMgmtBaseUrl,
        forecastIconResourceList,
        forecastIconSize,
        forecastIconSet,
        authId,
        secret,
        obsBaseUrl,
        snowSkiBaseUrl,
        stdParameters,
        user,
        resorts,
        tempUnit: user?.Units || temperatureUnits.fahrenheit
    };
};

const mapDispatchToProps = {
    getHourlyForecastByLatLon,
    getDailyForecastByLatLon,
    getCurrentStationObsByLatLon,
    getSnowSki
};

// eslint-disable-next-line react/display-name
const SnowSkiPage =  reduxConnect( mapStoreStateToProps, mapDispatchToProps ) (memo(({
    latitude,
    longitude,
    openNavMenu,
    forecastBaseUrl,
    contentMgmtBaseUrl,
    forecastIconResourceList,
    forecastIconSize,
    forecastIconSet,
    authId,
    secret,
    obsBaseUrl,
    stdParameters,
    user,
    getHourlyForecastByLatLon,
    getDailyForecastByLatLon,
    getCurrentStationObsByLatLon,
    snowSkiBaseUrl,
    getSnowSki,
    resorts,
    tempUnit
}) => {
    const fetchSnowSkiData = useCallback((snowSkiBaseUrl, authId, secret, latitude, longitude, tempUnit) => {
        try {
            if (latitude && longitude) {
                getSnowSki(snowSkiBaseUrl, authId, secret, latitude, longitude, tempUnit);
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        fetchSnowSkiData(snowSkiBaseUrl, authId, secret, latitude, longitude, tempUnit);
    }, [snowSkiBaseUrl, authId, secret, latitude, longitude, tempUnit]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!resorts.length) {
        return null;
    }
    return (
        <SnowSkiPageView
            resortArray={resorts}
            userLatitude={latitude}
            userLongitude={longitude}
            openNavMenu={openNavMenu}
            forecastBaseUrl={forecastBaseUrl}
            contentMgmtBaseUrl={contentMgmtBaseUrl}
            forecastIconResourceList={forecastIconResourceList}
            forecastIconSize={forecastIconSize}
            forecastIconSet={forecastIconSet}
            authId={authId}
            secret={secret}
            obsBaseUrl={obsBaseUrl}
            stdParameters={stdParameters}
            user={user}
            getHourlyForecastByLatLon={getHourlyForecastByLatLon}
            getDailyForecastByLatLon={getDailyForecastByLatLon}
            getCurrentStationObsByLatLon={getCurrentStationObsByLatLon}
            tempUnit={tempUnit}
            getSnowSki={getSnowSki}
            snowSkiBaseUrl={snowSkiBaseUrl}
        />
    );
}));

SnowSkiPage.displayName = 'SnowSkiPage';
SnowSkiPage.propTypes = {
    authId: PropTypes.string,
    secret: PropTypes.string,
    stdParameters: PropTypes.object,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    openNavMenu: PropTypes.func,
    forecastBaseUrl: PropTypes.string,
    contentMgmtBaseUrl: PropTypes.string,
    forecastIconResourceList: PropTypes.string,
    forecastIconSize: PropTypes.string,
    forecastIconSet: PropTypes.string,
    obsBaseUrl: PropTypes.string,
    user: PropTypes.object,
    getHourlyForecastByLatLon: PropTypes.func,
    getDailyForecastByLatLon: PropTypes.func,
    getCurrentStationObsByLatLon: PropTypes.func
};

export { SnowSkiPage as default };
